
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerize-alternative",
      function () {
        return require("private-next-pages/partnerize-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnerize-alternative"])
      });
    }
  